exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "nav[data-v-7e3aef84]{position:absolute;bottom:5px;right:10px;z-index:99;background-color:red}.nav[data-v-7e3aef84]{background:#ff0;border-radius:50%;width:30px;height:30px;font-size:1.7rem;margin:0 2px}.nav.disabled[data-v-7e3aef84]{display:none;pointer-events:none;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7e3aef84","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navigation.vue
// module id = 88
// module chunks = 0